import React, { useMemo, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { apiPost } from "../../utils/api";
import { useHistory, Link } from "react-router-dom";

const MemberCreate = () => {
  const history = useHistory();

  const [name, setName] = useState("");
  const [link_curriculum, setLinkCurriculum] = useState("");
  const [institution, setInstitution] = useState("");

  const [snack, setSnack] = useState({
    open: false,
    message: "Default message",
    severity: "success",
  });

  const showSnack = (message, severity) => {
    setSnack({
      ...snack,
      open: true,
      message: message,
      severity: severity,
    });
  };

  const handleSnackClose = (e) => {
    setSnack({ ...snack, open: false });
  };

  const member = useMemo(() => {
    return { name, link_curriculum, institution };
  }, [name, link_curriculum, institution]);

  async function criaMembro(state) {
    console.debug("cria membro");
    const payload = apiPost("/members", state);
    return await payload;
  }

  async function toLogin() {
    history.push("/login");
  }

  const submitHandler = (e) => {
    e.preventDefault();

    if (member.name.trim().length === 0) {
      showSnack("O nome deve ser preenchido!", "warning");
      return;
    }
    if (member.institution.trim().length === 0) {
      showSnack("O nome da instituição deve ser preenchido!", "warning");
      return;
    }
    if (member.link_curriculum.trim().length === 0) {
      showSnack(
        "O link para o currículo lattes deve ser preenchido!",
        "warning"
      );
      return;
    }

    criaMembro(member).then(
      (payload) => {
        // limpa os campos
        setInstitution("");
        setLinkCurriculum("");
        setName("");

        showSnack("Membro criado com sucesso!", "success");
      },
      (error) => {
        let message = "Erro ao criar a notícia. Tente novamente!";

        if (error.response.status === 401) {
          message = "Sem autorização.";
          toLogin();
        }

        showSnack(message, "error");
      }
    );
  };

  return (
    <>
      <section id="management" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Cadastrar novo membro</h2>
        </div>
      </section>

      <div className="row mx-5 justify-content-center">
        <div className="col-md-5">
          <form onSubmit={submitHandler}>
            <label htmlFor="name">Nome:</label>
            <input
              type="text"
              name="name"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />

            <label htmlFor="institution">Instituição:</label>
            <input
              type="text"
              name="institution"
              onChange={(e) => setInstitution(e.target.value)}
              value={institution}
            />

            <label htmlFor="lattes">Link para o currículo Lattes:</label>
            <input
              type="text"
              name="lattes"
              onChange={(e) => setLinkCurriculum(e.target.value)}
              value={link_curriculum}
            />

            <input type="submit" value="Cadastrar" />
          </form>

          <Snackbar
            open={snack.open}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity={snack.severity}
              sx={{ width: "100%" }}
            >
              {snack.message}
            </Alert>
          </Snackbar>

          <div>
            <Link className="btn btn-secondary" to="/management/members/admin">
              Voltar
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default MemberCreate;
